//
import React from "react";
//component
import FormTextArea from "component/form/form_textarea";
import { Button, Col, Divider, Form, Modal, Row } from "antd";
//redux
//selector
import { draftDialogOpenDenySelector } from "store/bailiff/draft/dialog/draft_dialog.selector";
//actions
//utils
//hook
import { useSelector } from "react-redux";
import { useDialogQCClone } from "hook/draft/dialog/useDialogsQCClone";
//str

const DialogQCDeny = () => {
  // -------------------------- VAR -----------------------------
  const { loading, handleCloseDeny, handleRateFail } = useDialogQCClone();
  const [form] = Form?.useForm();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const open = useSelector(draftDialogOpenDenySelector);
  // -------------------------- FUNCTION ------------------------
  const handleConfirm = () => {
    form
      ?.validateFields()
      .then((values) => {
        if (values) {
          const reason = values?.reason;
          return handleRateFail({ reason, form });
        }
      })
      .catch((err) => {
        console.log({ err });
      });
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Modal
      open={open}
      onCancel={() => handleCloseDeny(form)}
      title="Lý do từ chối đoạn hội thoại này"
      footer={null}
      centered
    >
      <Form layout="vertical" form={form} id="dialog-qc-deny">
        <Divider />
        <Row>
          <Col xl={24} lg={24} md={24} xs={24}>
            <FormTextArea placeholder="Điền lý do" name="reason" />
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <Button
              onClick={handleConfirm}
              loading={loading}
              type="primary"
              block
            >
              Xác Nhận
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};
export default DialogQCDeny;
